import React from 'react';
import classNames from 'classnames';
import SwapVert from '@/lib/vendor/@material-ui/icons/src/SwapVert';
import { defineStyles } from '../hooks/defineStyles';
import { useStyles } from '../hooks/useStyles';

const styles = defineStyles("SortButton", (theme: ThemeType) => ({
  icon: {
    cursor: "pointer",
    color: theme.palette.grey[600],
    fontSize: 18,
  },
  iconWithLabelGroup: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  iconWithLabel: {
    marginRight: 4,
  },
  label: {
    ...theme.typography.body2,
    fontSize: 14,
    color: theme.palette.grey[600],
  },
}))

const SortButton = ({className, onClick, showIcon=true, label=""}: {
  className?: string,
  onClick?: any,
  label?: React.JSX.Element|string,
  showIcon?: boolean
}) => {
  const classes = useStyles(styles);
  if (label) {
    return <span className={classes.iconWithLabelGroup} onClick={onClick}>
      {showIcon && <SwapVert className={classNames(classes.icon, classes.iconWithLabel, className)}/>}
      <span className={classes.label}>{ label }</span>
    </span>
  }
  return <SwapVert className={classNames(classes.icon, className)} onClick={onClick}/>
}

export default SortButton;


